export const SSO_BUSINESS_ACCOUNTS_KEY = "businessAccounts";
export const SSO_GOVERNMENT_ACCOUNTS_KEY = "governmentAccounts";

export function readSsoScratch(key: string): string | null {
	if (typeof sessionStorage !== "undefined") {
		const fromSession = sessionStorage.getItem(key);
		if (fromSession != null) return fromSession;
	}

	if (typeof localStorage === "undefined") return null;
	const legacy = localStorage.getItem(key);
	if (legacy == null) return null;
	try {
		sessionStorage?.setItem(key, legacy);
	} catch {}
	localStorage.removeItem(key);
	return legacy;
}

export function writeSsoScratch(key: string, value: string): void {
	if (typeof sessionStorage !== "undefined") {
		sessionStorage.setItem(key, value);
	}
	if (typeof localStorage !== "undefined") {
		localStorage.removeItem(key);
	}
}

export function clearSsoScratch(key: string): void {
	if (typeof sessionStorage !== "undefined") {
		sessionStorage.removeItem(key);
	}
	if (typeof localStorage !== "undefined") {
		localStorage.removeItem(key);
	}
}

export function hasSsoScratch(key: string): boolean {
	return readSsoScratch(key) != null;
}

export function readSsoScratchJson<T>(key: string): T | null {
	const raw = readSsoScratch(key);
	if (raw == null) return null;
	try {
		return JSON.parse(raw) as T;
	} catch {
		return null;
	}
}
